a.checkout = (function(){
	return {}
}());